import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingHero() {
  return (
    <section
      style={{
        background: '#ffffff',
        minHeight: 'calc(100vh - 60px)',
        display: 'flex',
        alignItems: 'center',
        fontFamily: "'Plus Jakarta Sans', sans-serif"
      }}>

      <div
        style={{ maxWidth: 1120, margin: '0 auto', padding: '80px 24px', width: '100%', display: 'flex', alignItems: 'center', gap: 64 }}
        className="hero-inner">

        {/* Left: copy */}
        <div style={{ flex: '1 1 0', minWidth: 0 }}>
          {/* Badge */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 999, padding: '5px 14px', marginBottom: 28 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#EA580C', display: 'inline-block' }} />
            <span style={{ fontSize: 13, fontWeight: 600, color: '#EA580C', letterSpacing: '0.01em' }}>Para recuperadores de metales</span>
          </div>

          {/* H1 */}
          <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.4rem)', fontWeight: 800, color: '#0f172a', lineHeight: 1.1, letterSpacing: '-0.03em', maxWidth: 580, margin: '0 0 24px' }}>
            Compra cada lote al precio exacto.
          </h1>

          {/* Subtext */}
          <p style={{ fontSize: '1.05rem', color: '#64748b', lineHeight: 1.65, maxWidth: 500, margin: '0 0 36px', fontWeight: 400 }}>MetalRecovery calcula en tiempo real el precio máximo de compra de cada lote de chatarra y gestiona el riesgo de tu inventario. Sin Excel. Sin estimaciones.

          </p>

          {/* Buttons */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 28 }} className="hero-buttons">
            <Link
              to="/login"
              className="hero-cta-primary"
              style={{
                background: '#EA580C',
                color: '#ffffff',
                fontSize: 15,
                fontWeight: 700,
                textDecoration: 'none',
                padding: '14px 28px',
                borderRadius: 999,
                display: 'inline-block',
                transition: 'background 0.15s, transform 0.1s',
                boxShadow: '0 4px 14px rgba(234,88,12,0.25)'
              }}
              onMouseEnter={(e) => {e.currentTarget.style.background = '#c2410c';e.currentTarget.style.transform = 'translateY(-1px)';}}
              onMouseLeave={(e) => {e.currentTarget.style.background = '#EA580C';e.currentTarget.style.transform = 'translateY(0)';}}>

              Probar la demo gratis
            </Link>
            <a
              href="#como-funciona"
              className="hero-cta-secondary"
              style={{ color: '#64748b', fontSize: 15, fontWeight: 500, textDecoration: 'none', padding: '14px 4px', borderBottom: '1px solid transparent', transition: 'border-color 0.15s, color 0.15s' }}
              onMouseEnter={(e) => {e.currentTarget.style.borderBottomColor = '#94a3b8';e.currentTarget.style.color = '#334155';}}
              onMouseLeave={(e) => {e.currentTarget.style.borderBottomColor = 'transparent';e.currentTarget.style.color = '#64748b';}}>

              Ver cómo funciona ↓
            </a>
          </div>

          {/* Trust signals */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
            {['Sin tarjeta de crédito', 'Datos demo incluidos', 'Configuración en 5 min']?.map((t) =>
            <span key={t} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#94a3b8', fontWeight: 500 }}>
                <span style={{ color: '#22c55e', fontWeight: 700 }}>✓</span> {t}
              </span>
            )}
          </div>
        </div>

        {/* Right: calculator card mockup */}
        <div style={{ flex: '0 0 360px', display: 'flex', justifyContent: 'center', width: '100%' }} className="hero-card-wrap">
          <div style={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: 20,
            padding: '28px 24px 24px',
            width: '100%',
            maxWidth: 340,
            boxShadow: '0 8px 40px rgba(15,23,42,0.08), 0 2px 8px rgba(15,23,42,0.04)',
            position: 'relative',
            boxSizing: 'border-box'
          }}>
            {/* Card header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Calculadora de lote</span>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', display: 'inline-block', boxShadow: '0 0 0 3px rgba(34,197,94,0.15)' }} />
            </div>

            {/* Metal row */}
            <div style={{ background: '#f8fafc', borderRadius: 10, padding: '10px 14px', marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>Metal</span>
              <span style={{ fontSize: 13, color: '#0f172a', fontWeight: 700 }}>Cobre LME</span>
            </div>

            {/* Weight row */}
            <div style={{ background: '#f8fafc', borderRadius: 10, padding: '10px 14px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>Peso</span>
              <span style={{ fontSize: 13, color: '#0f172a', fontWeight: 700 }}>12,5 t</span>
            </div>

            {/* Divider */}
            <div style={{ height: 1, background: '#f1f5f9', marginBottom: 20 }} />

            {/* Result */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>Precio máximo de compra</div>
              <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 'clamp(28px, 7vw, 36px)', fontWeight: 600, color: '#EA580C', letterSpacing: '-0.02em', lineHeight: 1 }}>8.240 €/t</div>
            </div>

            {/* Risk badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 999, padding: '5px 12px' }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#16a34a', display: 'inline-block' }} />
              <span style={{ fontSize: 12, fontWeight: 700, color: '#16a34a' }}>Riesgo BAJO</span>
            </div>

            {/* Decorative orange line */}
            <div style={{ position: 'absolute', top: 0, left: 28, right: 28, height: 3, background: 'linear-gradient(90deg, #EA580C, #F97316)', borderRadius: '0 0 4px 4px' }} />
          </div>
        </div>
      </div>
      <style>{`
        @media (max-width: 860px) {
          .hero-inner {
            flex-direction: column !important;
            padding: 48px 20px 56px !important;
            gap: 36px !important;
          }
          .hero-card-wrap {
            flex: unset !important;
            width: 100% !important;
            max-width: 400px !important;
            margin: 0 auto !important;
          }
        }
        @media (max-width: 480px) {
          .hero-buttons {
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 10px !important;
          }
          .hero-cta-primary {
            text-align: center !important;
            padding: 15px 20px !important;
            font-size: 16px !important;
          }
          .hero-cta-secondary {
            text-align: center !important;
            padding: 12px 4px !important;
            border-bottom: none !important;
            color: #64748b !important;
          }
          .hero-card-wrap {
            max-width: 100% !important;
          }
        }
      `}</style>
    </section>);

}